import "./style.scss";
import $ from "jquery";
import validate from "jquery-validation/dist/jquery.validate.min.js";
import disability from "./assets/images/disability.svg";
import firstNations from "./assets/images/first-nations.svg";
import lgbtiqa from "./assets/images/lgbtiqa.svg";
import multicultural from "./assets/images/multicultural.svg";
import womenAndGender from "./assets/images/women-and-gender.svg";

// Banner illustration is opt-in per embed, one at a time, e.g. ?first-nations
const illustrations = {
	"first-nations": firstNations,
	disability: disability,
	lgbtiqa: lgbtiqa,
	multicultural: multicultural,
	"women-and-gender": womenAndGender,
};

const validatePostcode = (postcode) => {
	const regexFourNumbers = /^[0-9]{4}$/;
	const trimmedPostcode = postcode.trim();
	const isValidPostcode = trimmedPostcode.match(regexFourNumbers);
	return isValidPostcode;
};

const postcode = document.querySelector("#postcode");
postcode.addEventListener("keyup", function () {
	const isValidPostcode = validatePostcode(postcode.value);
	if (isValidPostcode) {
		$(".postcode-error").fadeOut();
		$("#postcode").removeClass("error");
	}
	if (!isValidPostcode) {
		$(".postcode-error").fadeIn();
		$("#postcode").addClass("error");
		return;
	}
});

$(function () {
	const searchParams = new URLSearchParams(window.location.search);
	if (searchParams.has("first-nations-border")) {
		document.documentElement.classList.add("first-nations-border");
	}

	// no illustration unless the embed asks for one; first match wins if several are passed
	const illustration = Object.keys(illustrations).find((key) => searchParams.has(key));

	if (illustration) {
		const image = document.createElement("img");
		image.src = illustrations[illustration];
		image.alt = ""; // decorative, the banner title carries the meaning
		document.querySelector(".banner__art").appendChild(image);
		document.querySelector(".banner").classList.add("banner--has-art");
	}

	$("#would_you_like_to_be_contacted_yes").on("click", function () {
		$("#name_and_email").removeAttr("hidden");
	});

	$("#would_you_like_to_be_contacted_no").on("click", function () {
		$("#name_and_email").attr("hidden", "");
	});

	function ajaxSubmit(form) {
		const isValidPostcode = validatePostcode(postcode.value);

		if (!isValidPostcode) {
			$(".postcode-error").fadeIn();
			$("#postcode").addClass("error");
			return;
		}

		// fire ajax here
		$.ajax({
			url: "https://nzufbrn9z8.execute-api.us-east-1.amazonaws.com/",
			type: "POST",
			contentType: "application/json",
			dataType: "json",
			data: JSON.stringify({
				aboriginal_torres_strait_islander:
					document.querySelector('input[name="aboriginal_torres_strait_islander"]:checked')?.value || "",
				what: document.getElementById("what").value,
				where: document.getElementById("postcode").value,
				would_you_like_to_be_contacted: document.getElementById("would_you_like_to_be_contacted_no").checked
					? "No"
					: document.getElementById("would_you_like_to_be_contacted_yes").checked
					? "Yes"
					: "",
				name: document.getElementById("name").value,
				email: document.getElementById("email").value,
				url: window.location.origin,
				time: new Date().toLocaleString(),
			}),
			success: function success(result) {
				ajaxSuccess();
			},
			error: function error(xhr, resp, text) {
				ajaxFail();
			},
		});
	}

	function ajaxSuccess() {
		$("#contact").slideUp();
		// the form is gone, so move focus to the confirmation or the user lands nowhere
		$(".submitted").fadeIn(function () {
			this.querySelector("h3").focus();
		});

		if (typeof window.gtag !== "undefined") {
			// CRT form submission
			window.gtag("event", "form_submit", {
				"Host domain": window.document.referrer,
				event_category: "community_reporting_tool",
			});
		}
	}

	function ajaxFail() {
		$(".failed").fadeIn();
	}

	$("#contact").validate({
		submitHandler: function (form) {
			ajaxSubmit(form);
		},
		groups: {
			would_you_like_to_be_contacted: "would_you_like_to_be_contacted_yes would_you_like_to_be_contacted_no",
		},
		errorElement: "p",
		errorPlacement: function (error, element) {
			if (
				element.attr("id") === "would_you_like_to_be_contacted_yes" ||
				element.attr("id") === "would_you_like_to_be_contacted_no"
			) {
				error.insertAfter("#would_you_like_to_be_contacted");
			} else {
				error.insertAfter(element);
			}
		},
		rules: {
			would_you_like_to_be_contacted: {
				required: true,
			},
			name: {
				required: {
					depends: function (element) {
						return $("#would_you_like_to_be_contacted_yes").is(":checked");
					},
				},
			},
			email: {
				required: {
					depends: function (element) {
						return $("#would_you_like_to_be_contacted_yes").is(":checked");
					},
				},
			},
		},
	});
});
